import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, getAuthenticatedRedirectUrl } from "../../utils/auth";
import { getPendingVerificationPath } from "../../utils/authx-login-helpers";

/**
 * AuthRedirect component that redirects authenticated users to dashboard
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if not authenticated
 * @param {string} props.redirectTo - URL to redirect to if authenticated (default: "/user-dashboard")
 */
const AuthRedirect = ({ children, redirectTo }) => {
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthentication = async () => {
      // First check if already authenticated
      if (isAuthenticated()) {
        setAuthenticated(true);
        setIsCheckingAuth(false);
        return;
      }

      setAuthenticated(false);
      setIsCheckingAuth(false);
    };

    checkAuthentication();
  }, []);

  // Don't redirect if user is on verification/setup pages
  const currentPath = window.location.pathname;
  const allowedPaths = ['/verify-email', '/verify-phone', '/mfa', '/mfa-setup'];
  
  if (allowedPaths.some(path => currentPath.startsWith(path))) {
    return children;
  }

  const pendingVerificationPath = getPendingVerificationPath();
  if (pendingVerificationPath && !currentPath.startsWith(pendingVerificationPath)) {
    return <Navigate to={pendingVerificationPath} replace />;
  }

  // Show loading state while checking authentication
  if (isCheckingAuth) {
    return <div>Loading...</div>; // You can replace this with a proper loading component
  }

  if (authenticated) {
    return <Navigate to={redirectTo || getAuthenticatedRedirectUrl()} replace />;
  }

  return children;
};

export default AuthRedirect;
